export default __webpack_public_path__ + "static/media/dark_arrow.a0e9d99d.svg";